<p>
	I would appreciate it if you could spend 30 minutes of your time to discuss this urgent topic with
	me.
</p>
